import React from "react";
import { Text } from "@chakra-ui/react";
export function StatsItemTitle(props) {
    return (React.createElement(Text, { as: "span", fontSize: "sm", fontWeight: "semibold", textTransform: "uppercase", letterSpacing: "0.03em", color: "gray.600", ...props }));
}
